export default __webpack_public_path__ + "static/media/loaded.1141a0a2.svg";